export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-sound-86f4770ff2ffe7e8c1a036442aa9b1d1.svg";